import { refreshAccessToken } from "@/api/auth/refresh-access-token";
import { authService } from "@/services/auth";
import { QueryClient, queryOptions, useQuery } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { authKeys } from "./keys";

const FIFTEEN_MINUTES = 15 * 60 * 1000;

export function getRefreshAccessTokenOptions() {
	return queryOptions({
		queryKey: authKeys.refreshAccessToken(),
		queryFn: async () => {
			try {
				const data = await refreshAccessToken();
				authService.setToken(data);
				return data;
			} catch {
				return handleAuthError();
			}
		},
		refetchInterval: FIFTEEN_MINUTES,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true,
		staleTime: FIFTEEN_MINUTES,
		gcTime: FIFTEEN_MINUTES,
		retry: false,
	});
}

export function useRefreshAccessToken() {
	return useQuery(getRefreshAccessTokenOptions());
}

export async function ensureFreshToken(queryClient: QueryClient) {
	try {
		await queryClient.fetchQuery(getRefreshAccessTokenOptions());
	} catch {
		return handleAuthError();
	}
}

export function handleAuthError(): never {
	authService.clearToken();
	throw redirect({ to: "/sign-mail" });
}
